import { FC } from 'react';
import { animated, easings, useSpring } from 'react-spring';

import { Box, Notification, NotificationAlignment } from '@base-app';
import { useGetNotifications } from '@modules/notifications/store';
import { Notification as INotification } from '@modules/notifications/types';
import { NotificationsStyled } from './Notifications.style';

const Notifications: FC = () => {
  const notifications = useGetNotifications();

  const [styles] = useSpring(() => ({
    from: { opacity: 0, transform: 'translateY(-50px)' },
    to: { opacity: 1, transform: 'translateY(25px)' },
    config: {
      duration: 1000,
      easing: easings.easeInOutQuart,
    },
  }));

  return (
    <NotificationsStyled>
      <Box style={{ display: 'flex', flexDirection: 'column' }}>
        {notifications.map(({ autoClose, id, description, title, type }: INotification, index: number) => (
          <animated.div style={styles} key={index}>
            <Notification
              autoClose={autoClose}
              banner={true}
              css={{
                display: 'inline-flex',
                minWidth: '$notificationMinWidth',
                maxWidth: 'auto',
                margin: 'auto',
                marginBottom: '$4',
              }}
              description={description}
              id={id}
              textAlign={description ? NotificationAlignment.LEFT : NotificationAlignment.CENTER}
              title={title}
              variant={type}
            />
          </animated.div>
        ))}
      </Box>
    </NotificationsStyled>
  );
};

export default Notifications;
